module.exports = __webpack_public_path__ + "img/0Q3A5610_L_Black.4ab3c863.jpg";